import {useEffect, useState} from 'react';

// Tracks the Tailwind `lg` breakpoint (>=1024px) in JS. Needed because the
// detail pane needs to switch between an inline split-pane column (desktop)
// and a portal-rendered right-side Modal drawer (mobile) — a CSS-only
// `lg:hidden` wrapper can't stop the Modal's portal from mounting on desktop.
export default function useIsLgUp(): boolean {
  const [isLgUp, setIsLgUp] = useState(() =>
    typeof window !== 'undefined'
      ? window.matchMedia('(min-width: 1024px)').matches
      : true,
  );

  useEffect(() => {
    const mql = window.matchMedia('(min-width: 1024px)');
    const handler = (e: MediaQueryListEvent) => setIsLgUp(e.matches);
    mql.addEventListener?.('change', handler);
    return () => mql.removeEventListener?.('change', handler);
  }, []);

  return isLgUp;
}
